export const STATUS_META = {
  pending_payment: { label: "Awaiting Deposit", color: "text-[#ffd600] border-[#ffd600]/40 bg-[#ffd600]/10" },
  awaiting_payment: { label: "Awaiting Payment", color: "text-[#ff6a13] border-[#ff6a13]/40 bg-[#ff6a13]/10" },
  payment_received: { label: "Payment Received", color: "text-[#10b981] border-[#10b981]/40 bg-[#10b981]/10" },
  queued: { label: "Queued for RIP", color: "text-[#22c3d6] border-[#22c3d6]/40 bg-[#22c3d6]/10" },
  printing: { label: "Printing in Progress", color: "text-[#ffd600] border-[#ffd600]/40 bg-[#ffd600]/10" },
  cured: { label: "Cured & Inspected", color: "text-[#ff007a] border-[#ff007a]/40 bg-[#ff007a]/10" },
  shipped: { label: "Ready for Collection", color: "text-[#10b981] border-[#10b981]/40 bg-[#10b981]/10" },
  cancelled: { label: "Cancelled", color: "text-red-400 border-red-500/40 bg-red-500/10" },
};

export const STATUS_FLOW = ["queued", "printing", "cured", "shipped"];
export const ALL_STATUSES = ["pending_payment", "awaiting_payment", "payment_received", "queued", "printing", "cured", "shipped"];

export function StatusPill({ status }) {
  const m = STATUS_META[status] || STATUS_META.pending_payment;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-mono-p font-medium px-2.5 py-1 rounded-full border ${m.color}`} data-testid="status-pill">
      <span className="w-1.5 h-1.5 rounded-full bg-current" />{m.label}
    </span>
  );
}
